import { useContext } from "react";
import { AppContext } from "../App";
import { MdMenu } from "react-icons/md";

export default function MainMenuBtn() {
  const appContext = useContext(AppContext);

  return (
    <button
      type="button"
      className="MainMenuBtn mMobileOnly"
      data-sidebar-open={appContext.isSideBarOpen}
      onClick={() => appContext.setIsSideBarOpen(true)}
      aria-label="Open navigation menu"
    >
      <MdMenu />
    </button>
  );
}
